import api from "../api";
import {
  OrderInvoiceReportFilterDTO,
  OrderInvoiceReportRow,
  OrderInvoiceReportResponse,
} from "../../models/order-invoice-report-model";

class OrderInvoiceReportService {
  getReport = async (
    filter: OrderInvoiceReportFilterDTO
  ): Promise<OrderInvoiceReportResponse> => {
    try {
      const response = await api.post("/api/OrderInvoice/GetOrderInvoiceReport", filter);
      const data = response?.data;

      // If the API returns a paginated wrapper { data: [], totalRecords: N }
      if (data && typeof data === "object" && !Array.isArray(data) && "totalRecords" in data) {
        return data as OrderInvoiceReportResponse;
      }

      // Fallback: API returns a flat array — wrap it
      const rows: OrderInvoiceReportRow[] = Array.isArray(data)
        ? data
        : (data as any)?.data ?? (data as any)?.result ?? (data as any)?.items ?? [];

      return { data: rows, totalRecords: rows.length };
    } catch (error) {
      console.error("Error fetching order invoice timeline report:", error);
      throw error;
    }
  };
}

export default new OrderInvoiceReportService();
